/// <amd-module name="Analytics/Shared/ChartSeries/ChartSeries" />
export abstract class ChartSeries {
    constructor(
        protected _data: number[],
        protected _additionalData?: {
            data1: string;
            data2: string;
        } /* Additional data type is fixed which may not be true with all series implementor. */
    ) {}

    public abstract get name(): string;

    public abstract get values(): number[];

    public abstract get color(): string;

    public get minValue(): number {
        return 0;
    }

    public get maxValue(): number | null {
        return null;
    }

    public get allowDecimal(): boolean {
        return false;
    }
}
